import { createSlice } from "@reduxjs/toolkit";
import CommonUtil from "../../util/CommonUtils";

const initialState = {
    error: {},
    isLoading: false,
    loadingMessage: '',
    isModalOpen: false,
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setError: (state, action) => {
            if (!CommonUtil.isEmpty(action.payload)){
                state.error = {
                    message: action.payload?.message || 'Unknown error from server',
                    code: action.payload?.code || null,
                    status: action.payload?.response?.status || null,
                    url: action.payload?.config?.url || null,
                    responseData: action.payload?.response?.data || null,
                    timestamp: new Date().toISOString(),
                };
            }else{
                state.error={} 
            }
            state.isLoading =false;
        },
        clearError: (state) => {
            state.error = {};
        },
        setModalOpen: (state, action) => {
            state.isModalOpen = action.payload;
        },
        showLoader: (state, action) => {
            state.isLoading = true;
            state.loadingMessage = action.payload || '';
        },
        hideLoader: (state) => {
            state.isLoading = false;
            state.loadingMessage = '';
        },
    },
});

export const {
    setError,
    clearError,
    setModalOpen,
    showLoader,
    hideLoader
} = appSlice.actions;

export default appSlice.reducer;
